<template>
  <div>
    <GlobalForm
      class="global-form"
      :init-data="initData"
      :form-item-list="formItemList"
      :inline="true"
      :labelWidth="100"
      :needBtnLoading="true"
      round
      @handleConfirm="handleConfirm"
      confirmBtnName="查询"
    >
      <el-form-item v-if="isManager" label="员工姓名" slot="name">
        <el-select v-model="staffId" placeholder="请选择员工" clearable filterable>
          <el-option v-for="item in manageStaffList" :key="item.staffId" :label="item.staffName" :value="item.staffId" />
        </el-select>
      </el-form-item>
      <el-form-item
        v-else
        class="el_from"
        label="门店名称"
        slot="operationSelect"
        style="margin:0"
      >
        <el-select
          v-model="iid"
          placeholder="请选择门店"
          filterable
          clearable
        >
          <el-option
            v-for="item in shanpsSelectList"
            :key="item.key"
            :label="item.value"
            :value="item.key"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-button
        icon="el-icon-download"
        slot="AddSlot"
        type="success"
        :loading="exportLoading1"
        @click="exportExcel('01')"
        >导出红包统计</el-button
      >
      <el-button
        icon="el-icon-download"
        slot="AddSlot"
        type="warning"
        :loading="exportLoading2"
        @click="exportExcel('02')"
        >导出红包明细</el-button
      >
    </GlobalForm>
  </div>
</template>

<script>
import moment from "moment";
import _api from "@/utils/request";
import { MessageBox } from "element-ui";
export default {
  components: {},
  props: {
    isManager: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      initData: {
        entryTime: [
          moment()
            .day(moment().day() - 6)
            .format("YYYY-MM-DD 00:00:00"),
          moment().format("YYYY-MM-DD 23:59:59"),
        ],
      },
      pickerMinDate: null,
      pickerMaxDate: null,
      day31: 30 * 24 * 3600 * 1000,
      iid: null,
      staffId: '',
      merchantId: [],
      shanpsSelectList: [],
      manageStaffList: [],
      formItemList: [
        { slotName: "name" },
        { slotName: "operationSelect" },
        {
          key: "entryTime",
          type: "pickerOptions",
          labelName: "时间",
          placeholder: "请选择时间",
          valueFormat: "timestamp",
          pickerOptions: {
            onPick: ({ maxDate, minDate }) => {
              if (minDate && this.pickerMinDate) {
                this.pickerMinDate = null;
              } else if (minDate) {
                this.pickerMinDate = minDate.getTime();
              }
            },
            disabledDate: (time) => {
              if (this.pickerMinDate) {
                return (
                  time.getTime() > this.pickerMinDate + this.day31 ||
                  time.getTime() < this.pickerMinDate - this.day31
                );
              }
              return false;
            },
          },
        },
      ],
      params: {},
      exportLoading1: false,
      exportLoading2: false
    };
  },
  watch: {
    isManager() {
      this.staffId = undefined
      this.iid = undefined
      this.handleConfirm(this.initData)
    }
  },
  created() {
    let startTime = moment()
      .day(moment().day() - 6)
      .format("YYYY-MM-DD 00:00:00"); // 当前时间往前推15天的时间
    let endTime = moment().format("YYYY-MM-DD 23:59:59");
    startTime = Date.parse(startTime);
    endTime = Date.parse(endTime);
    this.params = {
      startTime,
      endTime
    }
    this.orderNo = this.$route.query.orderNo || "";
    _api.getStoreSelectOrder().then((res) => {
      if (res.code === 1) {
        this.shanpsSelectList = res.data;
      }
    });
    _api.manageStaffSelect().then(res => {
      this.manageStaffList = res.data
    })
  },
  mounted() {},
  methods: {
    handleConfirm(data,cd) {
      let SeachParams = {};
      if (data) {
        let startTime = "";
        let endTime = "";
        if (data.entryTime === null) {
          (startTime = ""), (endTime = "");
        } else {
          (startTime = moment(data.entryTime[0]).format("x")),
            (endTime = moment(data.entryTime[1]).format("x"));
        }
        SeachParams = {
          startTime: startTime,
          endTime: endTime,
          storeId: this.iid || "",
          staffId: this.staffId,
          isManager: this.isManager,
          pageNum: 1,
          pageSize: 10,
        };
      }
      this.params = JSON.parse(JSON.stringify(SeachParams));
      SeachParams.disuseLoding = () => {
        if (typeof cd === 'function') {
          cd()
        }
      },
      this.$store.commit("tagsView/SEACH_PARAMS", SeachParams);
    },
    handleChange(e) {
      this.iid = e;
    },
    exportExcel(type) {
      if (type == "01") {
        this.exportLoading1 = true
        _api.getCompanyStatisticExcel(this.params).then((res) => {
          const content = res;
          const blob = new Blob([content]);

          let reader = new FileReader(); // 创建读取文件对象
          reader.addEventListener("loadend", () => {
            try {
              let data = JSON.parse(reader.result);
              if (data.code === 0) {
                MessageBox.alert(data.msg || "服务异常", "错误提示", {
                  type: "error",
                });
              }
            } catch (err) {
              let start = moment(Number(this.params.startTime)).format("YYYY.MM.DD")
              let end = moment(Number(this.params.endTime)).format("YYYY.MM.DD")
              const fileName = `【员工红包统计】${start}-${end}.xlsx`;
              if ("download" in document.createElement("a")) {
                // 非IE下载
                const elink = document.createElement("a");
                elink.download = fileName;
                elink.style.display = "none";
                elink.href = URL.createObjectURL(blob);
                document.body.appendChild(elink);
                elink.click();
                URL.revokeObjectURL(elink.href); // 释放URL 对象
                document.body.removeChild(elink);
              } else {
                // IE10+下载
                navigator.msSaveBlob(blob, fileName);
              }
            }
          });
          reader.readAsText(blob, "utf-8");
        }).finally(() => {
            this.exportLoading1 = false;
          });
      }else{
        this.exportLoading2 = true
        _api.detailExcelAll(this.params).then((res) => {
          const content = res;
          const blob = new Blob([content]);

          let reader = new FileReader(); // 创建读取文件对象
          reader.addEventListener("loadend", () => {
            try {
              let data = JSON.parse(reader.result);
              if (data.code === 0) {
                MessageBox.alert(data.msg || "服务异常", "错误提示", {
                  type: "error",
                });
              }
            } catch (err) {
              let start = moment(Number(this.params.startTime)).format("YYYY.MM.DD")
              let end = moment(Number(this.params.endTime)).format("YYYY.MM.DD")
              const fileName = `【红包明细】${start}-${end}.xlsx`;
              if ("download" in document.createElement("a")) {
                // 非IE下载
                const elink = document.createElement("a");
                elink.download = fileName;
                elink.style.display = "none";
                elink.href = URL.createObjectURL(blob);
                document.body.appendChild(elink);
                elink.click();
                URL.revokeObjectURL(elink.href); // 释放URL 对象
                document.body.removeChild(elink);
              } else {
                // IE10+下载
                navigator.msSaveBlob(blob, fileName);
              }
            }
          });
          reader.readAsText(blob, "utf-8");
        }).finally(() => {
            this.exportLoading2 = false;
          });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.global-form {
  /deep/.el-input__inner {
    width: 160px;
  }
}
</style>
